import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import vSelect from 'vue-select';

export default Vue.component('edit-project-grid', {
  template: require('./template.html'),
  name: 'edit-project-grid',
  components: {
    vSelect,
  },
  computed: {
    ...mapGetters(['currentSite']),
    noDynamicData() {
      const hasDynamic = this.currentSite.dynamic;
      return !hasDynamic || (hasDynamic && !this.currentSite.dynamic.serviceCompany);
    },
    categoryOptions() {
      let list = [];
      const enabled = this.currentSite.dynamic && this.currentSite.dynamic.serviceCompany;
      if (enabled) {
        list = enabled.categories;
      }
      return list;
    },
  },
  props: ['droplet', 'show-edit-bubble'],
  data() {
    return {
      bounceTime: null,
      display: {
        customList: false,
        hideFilters: false,
        paginate: 0,
        customCategories: null,
        sortKey: false,
        filterText: false,
        placeholder: false,
      },
    };
  },
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValues();
      }
    },
  },
  methods: {
    setInitialValues() {
      this.display.customList = this.droplet.customList;
      this.display.hideFilters = this.droplet.hideFilters;
      this.display.paginate = this.droplet.paginate;
      this.display.customCategories = _.clone(this.droplet.customCategories);
      this.display.sortKey = this.droplet.sortKey;
      this.display.filterText = this.droplet.filterText || '';
      this.display.placeholder = this.droplet.placeholder || '';
    },
    setPagination() {
      this._debounce(() => {
        this.$store.dispatch('setDropletVal', {
          drp: this.droplet,
          val: this.display.paginate,
          key: 'paginate',
        });
        this.bouncePlugin();
      }, 250);
    },
    updateCustomList() {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        val: this.display.customList,
        key: 'customList',
      });
      this.bouncePlugin();
    },
    updateHideFilters() {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        val: this.display.hideFilters,
        key: 'hideFilters',
      });
      this.bouncePlugin();
    },
    selectCategory(list) {
      if (list) {
        const val = _.clone(list);
        this.$store.dispatch('setDropletVal', {
          drp: this.droplet,
          key: 'customCategories',
          val,
        });
        this.bouncePlugin();
      }
    },
    updateSortKey() {
      const val = this.display.sortKey ? 'projectDate.date' : false;
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        val,
        key: 'sortKey',
      });
      this.bouncePlugin();
    },
    radioUpdate(val, key) {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key,
        val,
      });
      this.bouncePlugin();
    },
    updateFilterText() {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        val: this.display.filterText,
        key: 'filterText',
      });
      this._debounce(() => {
        this.bouncePlugin();
      }, 300);
    },
    bouncePlugin() {
      this.$vnode.context.destroyPlugin();
      clearInterval(this.bounceTime);
      this.bounceTime = setTimeout(() => {
        this.$vnode.context.initPlugin();
      }, 250);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/project-grid/components/_edit-options/index.js